<template>
  <div
    class="basic-marquee-container"
    @mouseenter="onHover"
    @mouseleave="onLeave"
    ref="container"
  >
    <div
      class="basic-marquee-content"
      :class="{ 'is-animating': isOverflowing && isHovered }"
      :style="{ '--marquee-distance': `-${overflowDistance}px` }"
      ref="content"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasicMarquee',
  data() {
    return {
      isOverflowing: false,
      isHovered: false,
      overflowDistance: 0,
      resizeObserver: null,
    }
  },
  methods: {
    checkOverflow() {
      if (this.$refs.container && this.$refs.content) {
        const diff = this.$refs.content.scrollWidth - this.$refs.container.clientWidth;
        if (diff > 0) {
          this.isOverflowing = true;
          this.overflowDistance = diff + 16; // Add a little padding to the end
        } else {
          this.isOverflowing = false;
          this.overflowDistance = 0;
        }
      }
    },
    onHover() {
      this.checkOverflow();
      this.isHovered = true;
    },
    onLeave() {
      this.isHovered = false;
    }
  },
  mounted() {
    this.checkOverflow();
    if (typeof ResizeObserver !== 'undefined') {
      this.resizeObserver = new ResizeObserver(() => {
        this.checkOverflow();
      });
      if (this.$refs.container) {
        this.resizeObserver.observe(this.$refs.container);
      }
    }
  },
  beforeDestroy() {
    if (this.resizeObserver && this.$refs.container) {
      this.resizeObserver.unobserve(this.$refs.container);
      this.resizeObserver.disconnect();
    }
  }
}
</script>

<style scoped>
.basic-marquee-container {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  position: relative;
}

.basic-marquee-content {
  display: inline-block;
  min-width: 100%;
  transition: transform 0.2s ease;
}

.is-animating {
  animation: marquee-scroll 4s linear infinite;
}

@keyframes marquee-scroll {
  0%, 10% {
    transform: translateX(0);
  }
  85%, 95% {
    transform: translateX(var(--marquee-distance));
  }
  100% {
    transform: translateX(0);
  }
}
</style>
